import { faBook, faChartArea, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { brand_colors, CyanProcess } from '../../helpers/brand_colors_helper';
import { changeColorOpacity, ifNavAllowed } from '../../helpers/general_helpers';
import { t } from '../../helpers/translation_helper';

class MarketPlace extends Component {
  state = {
    nav: [
      {
        id: 'new-market-place',
        name: 'MarketPlace',
        icon: faBook,
        path: '/market-place/new-market-place',
      },
      {
        id: 'orders-market-place',
        name: 'Orders',
        icon: faBook,
        path: '/market-place/orders-market-place',
      },
    ],
  };

  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    return (
      <div
        className='inner-blue-bar'
        style={{
          backgroundColor: changeColorOpacity(CyanProcess, 0.15),
          marginRight: dir == 1 ? 0 : 15,
          marginLeft: dir == 0 ? 0 : 15,
        }}>
        <ul>
          {this.state.nav.map((item, index) =>
            <li key={index}>
              <NavLink activeclassname='active' to={item.path}>
                <FontAwesomeIcon icon={item.icon} />
                <div className='px-2'>{t(item.name)}</div>
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(MarketPlace);
